import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import useAsyncRequest from "hooks/useAsyncRequest";
import type { ServerLicenseXmlGenerationMode } from "client/api/ServerLicenseApi";
import { getLicenseXmlById } from "client/api/ServerLicenseApi";
import { LicenseKeyXmlView } from "areas/licenses/component/LicenseKeyXmlView";

type LegacyLicenseKeyXmlDialogProps = {
  open: boolean;
  serverLicenseId: string;
  onClose: () => void;
};

// We wrap the API call so we don't load the XML until the dialog is visible
const wrappedApiCall = async (
  serverLicenseId: string,
  generationMode: ServerLicenseXmlGenerationMode,
  makeCall: boolean
) => {
  if (makeCall) return getLicenseXmlById(serverLicenseId, generationMode);
};

export function CloudLicenseKeyXmlDialog(props: LegacyLicenseKeyXmlDialogProps) {
  const { open, serverLicenseId, onClose } = props;

  const { data, loading, error } = useAsyncRequest(wrappedApiCall, serverLicenseId, "Cloud", open);

  return (
    <Dialog
      open={open}
      maxWidth={"md"}
      onClose={onClose}
      role="dialog"
      aria-labelledby="cloud-license-key-xml-dialog-title"
    >
      <DialogTitle id="cloud-license-key-xml-dialog-title">
        Cloud license key XML
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>This XML is for branch instances only.</DialogContentText>
        <LicenseKeyXmlView loading={loading} licenseXml={data?.licenseXml} error={error} />
      </DialogContent>
    </Dialog>
  );
}
